import { injectIntl } from 'react-intl';
import OverrideFeesForm from './OverrideFeesForm';

export default injectIntl(OverrideFeesForm);
